import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@redux/hooks";

type PickingSliceState = {
    resyncingIds: number[];
    errorsById: Record<number, string[]>;
};

const initialState: PickingSliceState = {
    resyncingIds: [],
    errorsById: {},
};

export const pickingSlice = createSlice({
    name: "picking",
    initialState,
    reducers: {
        startPickingResync: (state, action: PayloadAction<number>) => {
            const pickingId = action.payload;

            if (!state.resyncingIds.includes(pickingId)) {
                state.resyncingIds.push(pickingId);
            }

            delete state.errorsById[pickingId];
        },

        finishPickingResync: (state, action: PayloadAction<number>) => {
            const pickingId = action.payload;

            state.resyncingIds = state.resyncingIds.filter((id) => id !== pickingId);
            delete state.errorsById[pickingId];
        },

        failPickingResync: (
            state,
            action: PayloadAction<{
                pickingId: number;
                errors: string[];
            }>
        ) => {
            const { pickingId, errors } = action.payload;

            state.resyncingIds = state.resyncingIds.filter((id) => id !== pickingId);
            state.errorsById[pickingId] = errors;
        },

        clearPickingResyncError: (state, action: PayloadAction<number>) => {
            delete state.errorsById[action.payload];
        },
    },
});

export const selectPickingResyncingIds = (state: RootState) => state.picking.resyncingIds;

export const selectIsPickingResyncing = (pickingId: number) => (state: RootState) =>
    state.picking.resyncingIds.includes(pickingId);

export const selectPickingResyncErrors = (pickingId: number) => (state: RootState) =>
    state.picking.errorsById[pickingId];

export const {
    startPickingResync,
    finishPickingResync,
    failPickingResync,
    clearPickingResyncError,
} = pickingSlice.actions;

export default pickingSlice.reducer;
